(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ebits-blog-languages"] && !Shopify.designMode) return;
  try {
    function preserveEbitsLanguageContext(link) {
  const current = new URL(window.location.href);
  if (!link.dataset.ebitsLanguageBase) link.dataset.ebitsLanguageBase = link.href;
  const target = new URL(link.dataset.ebitsLanguageBase, current);
  const language = link.getAttribute('hreflang');
  if (!['da', 'en', 'sv'].includes(language)) return;
  const pagePath = current.pathname.replace(/^\/(?:da|en|sv)(?=\/|$)/, '') || '/';
  target.pathname = (language === 'en' ? '/en' : '') + pagePath;
  const allowed = new Set(['variant', 'q', 'type', 'page', 'sort_by', 'view', 'options[prefix]', 'options[unavailable_products]']);
  for (const key of new Set(current.searchParams.keys())) {
    if (!allowed.has(key) && !key.startsWith('filter.')) continue;
    if (target.searchParams.has(key)) continue;
    for (let value of current.searchParams.getAll(key)) {
      if (key === 'view' && /^magazine-(meshtastic|bluetooth|elektronik)-(da|en|sv)$/.test(value)) value = value.replace(/-(da|en|sv)$/, '-' + language);
      target.searchParams.append(key, value);
    }
  }
  if (!target.hash) target.hash = current.hash;
  link.href = target.href;
}
function prepareEbitsLanguageLinks() {
  document.querySelectorAll('[data-ebits-language-links] a[hreflang]').forEach(preserveEbitsLanguageContext);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', prepareEbitsLanguageLinks);
else prepareEbitsLanguageLinks();
document.addEventListener('shopify:section:load', prepareEbitsLanguageLinks);
document.addEventListener('click', event => {
  const link = event.target.closest('[data-ebits-language-links] a[hreflang]');
  if (link) preserveEbitsLanguageContext(link);
}, true);
  } catch(e) { console.error(e); }
})();

})();
